/* eslint-disable max-len */
import { Box, IconButton } from '@mui/material';
import React, { useContext, useMemo } from 'react';
import ReferencialContext from 'Shared/ReferencialContext';
import { TYPES_COMMANDES } from 'Shared/constants/order';
import AutoCompleteCmp from 'Shared/Select/AutoCompleteCmp';
import CachedIcon from '@mui/icons-material/Cached';
import RangeDate from 'Shared/RangeDate';
import { mapOrderStatus } from '../SageOrders/constants';

const STATUSLIST = Object.keys(mapOrderStatus).map((k) => ({
  id: k,
  value: mapOrderStatus[k].label,
}));
const Filters = ({
  values, handleInputChange, product, handleRefresh, type = false,
}) => {
  const {
    state: {
      referencial: {
        clients = [], expeditions, paymentModes, products,
      },
    },
  } = useContext(ReferencialContext);
  const cyties = useMemo(() => clients.map((c) => c.city).unique(), [clients]);
  // const classes = useStyles();
  const onRefresh = () => {
    handleRefresh();
  };

  const onChangeDate = (value, isStartDate) => {
    handleInputChange(isStartDate ? 'startDate' : 'endDate')({ target: { value } });
  };

  const rangeDates = {
    start: values.startDate != null && !(values.startDate instanceof Date) ? new Date(values.startDate) : values.startDate,
    end: values.endDate != null && !(values.endDate instanceof Date) ? new Date(values.endDate) : values.endDate,
  };
  return (
    <Box
      style={{
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      <AutoCompleteCmp
        autoSelect
        isPrimaryTheme
        style={{ maxWidth: 150 }}
        options={clients || []}
        onChange={handleInputChange('client')}
        value={values.client}
        label="Client"
        getOptionLabel={(option) => `${option.code} : ${option.name}`}
        filterOptions={(options, v) => options.filter(
          (option) => option.name?.toLowerCase().includes(v.inputValue.toLowerCase())
              || option.code?.toLowerCase().includes(v.inputValue.toLowerCase()),
        )}
      />
      <AutoCompleteCmp
        autoSelect
        isPrimaryTheme
        style={{ maxWidth: 150 }}
        options={expeditions || []}
        onChange={handleInputChange('expedition')}
        value={values.expedition}
        label="Expedition"
        getOptionLabel={(option) => option.name}
        filterOptions={(options, v) => options.filter((option) => option.name?.toLowerCase().includes(v.inputValue.toLowerCase()))}
      />
      <AutoCompleteCmp
        autoSelect
        isPrimaryTheme
        style={{ maxWidth: 150 }}
        options={paymentModes || []}
        onChange={handleInputChange('paymentMode')}
        value={values.paymentMode}
        label="Condition de livraison"
        getOptionLabel={(option) => option.name}
        filterOptions={(options, v) => options.filter((option) => option.name?.toLowerCase().includes(v.inputValue.toLowerCase()))}
      />
      <AutoCompleteCmp
        autoSelect
        isPrimaryTheme
        style={{ maxWidth: 150 }}
        options={cyties || []}
        onChange={handleInputChange('city')}
        value={values.city}
        getOptionLabel={(option) => option}
        filterOptions={(options, v) => options.filter((option) => option?.toLowerCase().includes(v.inputValue.toLowerCase()))}
        label="Ville"
      />
      {type && (
        <AutoCompleteCmp
          autoSelect
          isPrimaryTheme
          style={{ maxWidth: 150 }}
          options={TYPES_COMMANDES || []}
          onChange={handleInputChange('type')}
          value={values.type}
          getOptionLabel={(option) => option.label}
          filterOptions={(options, v) => options.filter((option) => option.label?.toLowerCase().includes(v.inputValue.toLowerCase()))}
          label="Type de pièce"
        />
      )}
      {product && (
        <AutoCompleteCmp
          autoSelect
          isPrimaryTheme
          style={{ maxWidth: 150 }}
          options={STATUSLIST || []}
          onChange={handleInputChange('status')}
          value={values.status}
          getOptionLabel={(option) => option.value}
          filterOptions={(options, v) => options.filter((option) => option.value.toLowerCase().includes(v.inputValue.toLowerCase()))}
          label="Statut"
        />
      )}
      {!product && (
        <AutoCompleteCmp
          autoSelect
          isPrimaryTheme
          style={{ maxWidth: 150 }}
          options={products || []}
          onChange={handleInputChange('product')}
          value={values.product}
          getOptionLabel={(option) => option.reference}
          filterOptions={(options, v) => options.filter((option) => option.reference.toLowerCase().includes(v.inputValue.toLowerCase()))}
          label="Produit"
        />
      )}
      <RangeDate
        value={rangeDates}
        handleChange={onChangeDate}
        text={{ start: 'Début', end: 'Fin' }}
        noMarginRightEnd
      />
      <IconButton
        color="primary"
        onClick={onRefresh}
        size="large"
        style={{
          background: '#FFFFFF 0% 0% no-repeat padding-box',
          borderRadius: 12,
          padding: 8,
          margin: 'auto',
          marginRight: 0,
        }}
      >
        <CachedIcon />
      </IconButton>
    </Box>
  );
};

export default Filters;
